import {
  FormHelperText,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Tab from "@material-ui/core/Tab";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tabs from "@material-ui/core/Tabs";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import {
  DistrictField,
  ProvinceField,
  SubDistrictField,
  useAddress,
  ZipcodeField,
} from "components/request-document/components/Address";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  TableRowHead,
  UploadButton,
  useStyles,
} from "components/request-document/components/Commons";
import CompanyInfoSection from "components/request-document/components/CompanyInfoSection";
import { useFormik } from "formik";
import {
  REQUEST_DOCUMENT_STEP,
  RoleId,
  STATUS_PROCESS,
} from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { openFileById } from "libs/utils/file";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig,
} from "redux/modules/visaForm";
import FileService from "services/FileService";
import * as yup from "yup";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function UserProfileStepB() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);
  const [coreTechnologyTab, setCoreTechnologyTab] = useState(0);

  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);
  const canEdit = useSelector(canEditForm);
  const personalId = get(personalDetail, "personalID", "");
  const activitiesConfig = get(masterData, "activitiesConfig", []);
  const assignmentConfig = get(masterData, "assignmentConfig", []);
  const technologyCoreConfig = get(masterData, "technologyCoreConfig", []);
  const technologyEmploymentConfig = get(
    masterData,
    "technologyEmploymentConfig",
    []
  );

  const detailList = [
    "CompanyRegisterNumber",
    "CompanyRegisterDate",
    "CompanyName",
    "CompanyAddress",
    "OfficeNumber",
    "CompanyWebSite",
    "ProductService",
    "MajorService",
    "SaleRevenune",
    "activitiesId",
    "activitiesIdSub",
    "ProcessDiagram",
    "Explanation",
    "assignmentId",
    "assignmentId2",
    "assignmentId3",
    "technologyCore",
    "technologyCoreExplain",
    "technologyEmployment",
    "technologyEmploymentExplain",
    "technologyCore2",
    "technologyCoreExplain2",
    "technologyEmployment2",
    "technologyEmploymentExplain2",
    "technologyCore3",
    "technologyCoreExplain3",
    "technologyEmployment3",
    "technologyEmploymentExplain3",
    "Address1",
    "SubDistrict1",
    "District1",
    "Province1",
    "Zipcode1",
    "Address2",
    "SubDistrict2",
    "District2",
    "Province2",
    "Zipcode2",
    "Address3",
    "SubDistrict3",
    "District3",
    "Province3",
    "Zipcode3",
  ];
  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  useEffect(() => {
    dispatch(
      getMasterData({
        ActivitiesConfig: true,
        AssignmentConfig: true,
        technologyCoreConfig: true,
        technologyEmploymentConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());

        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.PART_C));
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, isSaveDraft]);

  const callAPISubmit = async (values) => {
    showLoading();

    const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
    const documentFields = Object.keys(values);
    const getFieldListConfig = defaultType.filter((field) =>
      documentFields.includes(field.smartName)
    );

    const getValue = (field) => {
      switch (field.smartName) {
        case "ProcessDiagram": {
          const FileID = values?.ProcessDiagram?.FileID;
          if (!FileID) return null;
          return {
            ext: values?.ProcessDiagram?.ext || null,
            FileID: values?.ProcessDiagram?.FileID || null,
            filename: values?.ProcessDiagram?.filename || null,
            processfileID: values?.ProcessDiagram?.processfileID || null,
            Status: values?.ProcessDiagram?.Status || true,
          };
        }
        default:
          return get(values, `${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null,
      visaissuance: null,
      detail: [
        ...getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: getSmartId(field),
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      ],
    };

    console.log("prepareData => ", prepareData);

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };
  const defaultProcessDiagram = get(detail, "ProcessDiagram.value", "");
  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;
  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    initialValues: {
      CompanyRegisterNumber: get(detail, "CompanyRegisterNumber.value", ""),
      CompanyRegisterDate: get(detail, "CompanyRegisterDate.value", ""),
      CompanyName: get(detail, "CompanyName.value", ""),
      CompanyAddress: get(detail, "CompanyAddress.value", ""),
      OfficeNumber: get(detail, "OfficeNumber.value", ""),
      CompanyWebSite: get(detail, "CompanyWebSite.value", ""),
      ProductService: get(detail, "ProductService.value", ""),
      MajorService: get(detail, "MajorService.value", ""),
      SaleRevenune: get(detail, "SaleRevenune.value", ""),
      activitiesId: get(detail, "activitiesId.value", ""),
      activitiesIdSub: get(detail, "activitiesIdSub.value", ""),
      ProcessDiagram: {
        ext: defaultProcessDiagram.ext,
        FileID: defaultProcessDiagram.fileID,
        filename: defaultProcessDiagram.fileID,
        processfileID: defaultProcessDiagram.fileID,
        Status: defaultProcessDiagram.status || true,
      },
      Explanation: get(detail, "Explanation.value", ""),
      assignmentId: get(detail, "assignmentId.value", ""),
      assignmentId2: get(detail, "assignmentId2.value", ""),
      assignmentId3: get(detail, "assignmentId3.value", ""),
      technologyCore: get(detail, "technologyCore.value", ""),
      technologyCoreExplain: get(detail, "technologyCoreExplain.value", ""),
      technologyEmployment: get(detail, "technologyEmployment.value", ""),
      technologyEmploymentExplain: get(
        detail,
        "technologyEmploymentExplain.value",
        ""
      ),
      technologyCore2: get(detail, "technologyCore2.value", ""),
      technologyCoreExplain2: get(detail, "technologyCoreExplain2.value", ""),
      technologyEmployment2: get(detail, "technologyEmployment2.value", ""),
      technologyEmploymentExplain2: get(
        detail,
        "technologyEmploymentExplain2.value",
        ""
      ),
      technologyCore3: get(detail, "technologyCore3.value", ""),
      technologyCoreExplain3: get(detail, "technologyCoreExplain3.value", ""),
      technologyEmployment3: get(detail, "technologyEmployment3.value", ""),
      technologyEmploymentExplain3: get(
        detail,
        "technologyEmploymentExplain3.value",
        ""
      ),
      Address1: get(detail, "Address1.value", ""),
      SubDistrict1: get(detail, "SubDistrict1.value", ""),
      District1: get(detail, "District1.value", ""),
      Province1: get(detail, "Province1.value", ""),
      Zipcode1: get(detail, "Zipcode1.value", ""),
      Address2: get(detail, "Address2.value", ""),
      SubDistrict2: get(detail, "SubDistrict2.value", ""),
      District2: get(detail, "District2.value", ""),
      Province2: get(detail, "Province2.value", ""),
      Zipcode2: get(detail, "Zipcode2.value", ""),
      Address3: get(detail, "Address3.value", ""),
      SubDistrict3: get(detail, "SubDistrict3.value", ""),
      District3: get(detail, "District3.value", ""),
      Province3: get(detail, "Province3.value", ""),
      Zipcode3: get(detail, "Zipcode3.value", ""),
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });
  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => {};
    formik.handleChange = () => {};
    formik.setFieldValue = () => {};
  }

  const handleChangeTab = (event, newValue) => {
    setCoreTechnologyTab(newValue);
  };

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “E”"
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part B: Company Information
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <CompanyInfoSection colSpan={4} formik={formik} />

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={7} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Business or products or services description
                      </InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="ProductService"
                        value={formik.values.ProductService}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ProductService", formik)}
                        helperText={getErrorMessage("ProductService", formik)}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRowHead>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={8} />
                    <div className={classes.wrapField}>
                      <InputLabel>Major products or services</InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Sale revenue (Approximate in Baht)
                      </InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRowHead>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="MajorService"
                    value={formik.values.MajorService}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("MajorService", formik)}
                    helperText={getErrorMessage("MajorService", formik)}
                    multiline
                    rows={5}
                    rowsMin={5}
                    rowsMax={5}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="SaleRevenune"
                    value={formik.values.SaleRevenune}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("SaleRevenune", formik)}
                    helperText={getErrorMessage("SaleRevenune", formik)}
                    multiline
                    rows={5}
                    rowsMin={5}
                    rowsMax={5}
                  />
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={9} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Please choose the targeted industries most relevant to
                        your company’s activities
                      </InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel>Activities</InputLabel>
                        <Select
                          disabled={!canEdit}
                          label="Activities"
                          name="activitiesId"
                          value={formik.values.activitiesId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={{ width: 350 }}
                        >
                          {activitiesConfig.map((activities) => (
                            <MenuItem
                              key={activities.activitiesId}
                              value={activities.activitiesId}
                            >
                              {activities.activitiesName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={1}>
                  <div className={classes.cellContent}>
                    <Bagde number={9} />
                    <div className={classes.wrapField}>
                      <InputLabel>Sub activities</InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel>Sub activities</InputLabel>
                        <Select
                          disabled={!canEdit}
                          label="Sub activities"
                          name="activitiesIdSub"
                          value={formik.values.activitiesIdSub}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={{ width: 200 }}
                        >
                          {activitiesConfig.map((activities) => (
                            <MenuItem
                              key={activities.activitiesId}
                              value={activities.activitiesId}
                            >
                              {activities.activitiesName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRowHead>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={10} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Manufacturing/Service Process. Please provide a process
                        diagram that explains the manufacturing/service process
                        (additional documents can be attached).
                      </InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRowHead>
              <TableRowHead>
                <StyledTableCell colSpan={2} align="center">
                  <InputLabel>Process Diagram</InputLabel>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <InputLabel>Explanation</InputLabel>
                </StyledTableCell>
              </TableRowHead>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.flexRow}>
                    <InputLabel>File Upload ( PDF, JPG )</InputLabel>
                    <div style={{ width: 18 }} />
                    <UploadButton
                      disabled={!canEdit}
                      title={
                        get(formik.values, `ProcessDiagram.FileID`, "")
                          ? "Edit"
                          : "+ Add"
                      }
                      id={`upload-ProcessDiagram`}
                      onChange={async (event) => {
                        try {
                          const response = await FileService.uploadFile({
                            file: event.target.files[0],
                            Status: true,
                          });
                          const fileId = response.results?.fileID;
                          const [filename, ext] =
                            event.target.files[0].name.split(".");

                          formik.setFieldValue(`ProcessDiagram`, {
                            processfileID: fileId,
                            FileID: fileId,
                            filename,
                            ext,
                            Status: true,
                          });
                        } catch (error) {
                          console.log("Upload error", error);
                        }
                      }}
                    />
                    {get(formik.values, `ProcessDiagram.FileID`, "") && (
                      <IconButton
                        style={{ width: 40 }}
                        size="small"
                        onClick={async () => {
                          const processfileID = get(
                            formik.values,
                            `ProcessDiagram.FileID`,
                            ""
                          );

                          openFileById(processfileID);
                        }}
                      >
                        <VisibilityIcon />
                      </IconButton>
                    )}
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="Explanation"
                    value={formik.values.Explanation}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("Explanation", formik)}
                    helperText={getErrorMessage("Explanation", formik)}
                    multiline
                    rows={10}
                  />
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={11} />
                    <div>
                      <Typography>
                        Please select core technology used in the production
                        process or services provision
                      </Typography>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <Tabs
                    value={coreTechnologyTab}
                    onChange={handleChangeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                  >
                    <Tab
                      label="Please select core technology"
                      {...a11yProps(0)}
                    />
                    <Tab
                      label="Please select 2nd core technology"
                      {...a11yProps(1)}
                    />
                    <Tab
                      label="Please select 3nd core technology"
                      {...a11yProps(2)}
                    />
                  </Tabs>
                </StyledTableCell>
              </TableRow>

              {[
                {
                  assignment: {
                    fieldName: "assignmentId",
                    label: "Please select core technology",
                  },
                  technologyCore: {
                    fieldName: "technologyCore",
                    label: "Acquisition of core technology",
                  },
                  technologyCoreExplain: {
                    fieldName: "technologyCoreExplain",
                    label: "Please explain",
                  },
                  technologyEmployment: {
                    fieldName: "technologyEmployment",
                    label: "Objective of technology employment",
                  },
                  technologyEmploymentExplain: {
                    fieldName: "technologyEmploymentExplain",
                    label: "Please explain",
                  },
                  Address: {
                    fieldName: "Address1",
                  },
                  Subdistrict: {
                    fieldName: "SubDistrict1",
                  },
                  District: {
                    fieldName: "District1",
                  },
                  Province: {
                    fieldName: "Province1",
                  },
                  Zipcode: {
                    fieldName: "Zipcode1",
                  },
                },
                {
                  assignment: {
                    fieldName: "assignmentId2",
                    label: "Please select 2nd core technology",
                  },
                  technologyCore: {
                    fieldName: "technologyCore2",
                    label: "Acquisition of core technology",
                  },
                  technologyCoreExplain: {
                    fieldName: "technologyCoreExplain2",
                    label: "Please explain",
                  },
                  technologyEmployment: {
                    fieldName: "technologyEmployment2",
                    label: "Objective of technology employment",
                  },
                  technologyEmploymentExplain: {
                    fieldName: "technologyEmploymentExplain2",
                    label: "Please explain",
                  },
                  Address: {
                    fieldName: "Address2",
                  },
                  Subdistrict: {
                    fieldName: "SubDistrict2",
                  },
                  District: {
                    fieldName: "District2",
                  },
                  Province: {
                    fieldName: "Province2",
                  },
                  Zipcode: {
                    fieldName: "Zipcode2",
                  },
                },
                {
                  assignment: {
                    fieldName: "assignmentId3",
                    label: "Please select 3nd core technology",
                  },
                  technologyCore: {
                    fieldName: "technologyCore3",
                    label: "Acquisition of core technology",
                  },
                  technologyCoreExplain: {
                    fieldName: "technologyCoreExplain3",
                    label: "Please explain",
                  },
                  technologyEmployment: {
                    fieldName: "technologyEmployment3",
                    label: "Objective of technology employment",
                  },
                  technologyEmploymentExplain: {
                    fieldName: "technologyEmploymentExplain3",
                    label: "Please explain",
                  },
                  Address: {
                    fieldName: "Address3",
                  },
                  Subdistrict: {
                    fieldName: "SubDistrict3",
                  },
                  District: {
                    fieldName: "District3",
                  },
                  Province: {
                    fieldName: "Province3",
                  },
                  Zipcode: {
                    fieldName: "Zipcode3",
                  },
                },
              ].map((fields, index) => {
                if (index !== coreTechnologyTab) return null;

                return (
                  <React.Fragment key={index}>
                    <TableRow>
                      <StyledTableCell colSpan={3}>
                        <div className={classes.cellContent}>
                          <div className={classes.wrapField}>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              error={isError(
                                fields.assignment.fieldName,
                                formik
                              )}
                            >
                              <InputLabel>{fields.assignment.label}</InputLabel>
                              <Select
                                disabled={!canEdit}
                                label={fields.assignment.label}
                                name={fields.assignment.fieldName}
                                value={
                                  formik.values[fields.assignment.fieldName]
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                // style={{ width: 250 }}
                              >
                                {assignmentConfig.map((assignment) => (
                                  <MenuItem
                                    value={assignment.assignmentId}
                                    key={assignment.assignmentId}
                                  >
                                    {assignment.assignmentName}
                                  </MenuItem>
                                ))}
                              </Select>
                              <FormHelperText
                                error={isError(
                                  fields.assignment.fieldName,
                                  formik
                                )}
                              >
                                {getErrorMessage(
                                  fields.assignment.fieldName,
                                  formik
                                )}
                              </FormHelperText>
                            </FormControl>
                          </div>
                        </div>
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell colSpan={3}>
                        <div className={classes.cellContent}>
                          <Bagde number={12} />
                          <div className={classes.wrapField}>
                            <InputLabel>
                              {fields.technologyCore.label}
                            </InputLabel>
                            <FormGroup row>
                              {technologyCoreConfig.map((technologyCore) => (
                                <FormControlLabel
                                  key={technologyCore.technologyCoreID}
                                  control={
                                    <StyleCheckbox
                                      disabled={!canEdit}
                                      name={technologyCore.technologyCoreName}
                                      value={technologyCore.technologyCoreID}
                                      checked={
                                        formik.values[
                                          fields.technologyCore.fieldName
                                        ] === technologyCore.technologyCoreID
                                      }
                                      onClick={() => {
                                        formik.setFieldValue(
                                          fields.technologyCore.fieldName,
                                          technologyCore.technologyCoreID
                                        );
                                      }}
                                    />
                                  }
                                  label={technologyCore.technologyCoreName}
                                />
                              ))}
                            </FormGroup>
                          </div>
                        </div>
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell colSpan={3}>
                        <div className={classes.cellContent}>
                          <div className={classes.wrapField}>
                            <InputLabel>
                              {fields.technologyCoreExplain.label}
                            </InputLabel>
                            <TextField
                              disabled={!canEdit}
                              variant="outlined"
                              className={classes.textField}
                              name={fields.technologyCoreExplain.fieldName}
                              value={
                                formik.values[
                                  fields.technologyCoreExplain.fieldName
                                ]
                              }
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={isError(
                                fields.technologyCoreExplain.fieldName,
                                formik
                              )}
                              helperText={getErrorMessage(
                                fields.technologyCoreExplain.fieldName,
                                formik
                              )}
                              multiline
                              rows={5}
                              rowsMin={5}
                              rowsMax={5}
                            />
                          </div>
                        </div>
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell colSpan={3}>
                        <div className={classes.cellContent}>
                          <Bagde number={13} />
                          <div className={classes.wrapField}>
                            <InputLabel>
                              {fields.technologyEmployment.label}
                            </InputLabel>
                            <FormGroup row>
                              {technologyEmploymentConfig.map(
                                (technologyEmployment) => (
                                  <FormControlLabel
                                    style={{ marginBottom: 8 }}
                                    key={
                                      technologyEmployment.technologyEmploymentID
                                    }
                                    control={
                                      <StyleCheckbox
                                        disabled={!canEdit}
                                        name={
                                          technologyEmployment.technologyEmploymentName
                                        }
                                        value={
                                          technologyEmployment.technologyEmploymentID
                                        }
                                        checked={
                                          formik.values[
                                            fields.technologyEmployment
                                              .fieldName
                                          ] ===
                                          technologyEmployment.technologyEmploymentID
                                        }
                                        onClick={() => {
                                          formik.setFieldValue(
                                            fields.technologyEmployment
                                              .fieldName,
                                            technologyEmployment.technologyEmploymentID
                                          );
                                        }}
                                      />
                                    }
                                    label={
                                      technologyEmployment.technologyEmploymentName
                                    }
                                  />
                                )
                              )}
                            </FormGroup>
                          </div>
                        </div>
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell colSpan={3}>
                        <div className={classes.cellContent}>
                          <div className={classes.wrapField}>
                            <InputLabel>
                              {fields.technologyEmploymentExplain.label}
                            </InputLabel>
                            <TextField
                              disabled={!canEdit}
                              variant="outlined"
                              className={classes.textField}
                              name={
                                fields.technologyEmploymentExplain.fieldName
                              }
                              value={
                                formik.values[
                                  fields.technologyEmploymentExplain.fieldName
                                ]
                              }
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={isError(
                                fields.technologyEmploymentExplain.fieldName,
                                formik
                              )}
                              helperText={getErrorMessage(
                                fields.technologyEmploymentExplain.fieldName,
                                formik
                              )}
                              multiline
                              rows={5}
                              rowsMin={5}
                              rowsMax={5}
                            />
                          </div>
                        </div>
                      </StyledTableCell>
                    </TableRow>

                    {/* <TableRow>
                      <StyledTableCell colSpan={3}>
                        <div className={classes.cellContent}>
                          <div className={classes.wrapField}>
                            <InputLabel>Address</InputLabel>
                            <TextField
                              disabled={!canEdit}
                              variant="outlined"
                              className={classes.textField}
                              name={fields.Address.fieldName}
                              value={formik.values[fields.Address.fieldName]}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={isError(fields.Address.fieldName, formik)}
                              helperText={getErrorMessage(
                                fields.Address.fieldName,
                                formik
                              )}
                            />
                          </div>
                        </div>
                      </StyledTableCell>
                    </TableRow> */}

                    <Address
                      formik={formik}
                      SubDistrictFieldName={fields.Subdistrict.fieldName}
                      DistrictFieldName={fields.District.fieldName}
                      ProvinceFieldName={fields.Province.fieldName}
                      ZipcodeFieldName={fields.Zipcode.fieldName}
                    />
                  </React.Fragment>
                );
              })}

              <div />
            </TableBody>
          </Table>
        </TableContainer>
        <ButtonController
          onClickSaveDraft={() => {
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}

function Address({
  formik,
  ProvinceFieldName,
  DistrictFieldName,
  SubDistrictFieldName,
  ZipcodeFieldName,
}) {
  const addressFieldOptions = useAddress({
    formik,
    ProvinceFieldName,
    DistrictFieldName,
    SubDistrictFieldName,
    ZipcodeFieldName,
    shouldCheckHasAddress: false,
  });

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={1}>
          <ProvinceField {...addressFieldOptions} />
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <DistrictField {...addressFieldOptions} />
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={1}>
          <SubDistrictField {...addressFieldOptions} />
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <ZipcodeField {...addressFieldOptions} />
        </StyledTableCell>
      </TableRow>
    </>
  );
}
